import { defineMessages } from 'react-intl';

export const messages: {
	heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noUpdates: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showMore: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showMoreAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showLess: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterAll: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterPages: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterBlogPosts: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterComments: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterAttachments: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterWhiteboards: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterDatabases: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterEmbeds: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createdBy: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	updatedBy: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createdOn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	updatedOn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewChanges: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	permalink: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loadingLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	editCta: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contributedBy: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	commentedBy: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	commentedByPrefix: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	attachedBy: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	attachedByPrefix: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contributedByPrefix: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contributedOn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	heading: {
		id: 'recently-updated-macro.heading',
		defaultMessage: 'Recent updates',
		description: 'Heading shown above the list of recently updated content items',
	},
	noUpdates: {
		id: 'recently-updated-macro.no-updates',
		defaultMessage: 'No updates yet.',
		description: 'Message shown when there are no recently updated items to display',
	},
	showMore: {
		id: 'recently-updated-macro.show-more',
		defaultMessage: 'Show more',
		description: 'Link to load more recently updated content items',
	},
	showMoreAriaLabel: {
		id: 'recently-updated-macro.show-more-aria-label',
		defaultMessage: 'Show more recent updates',
		description:
			'Accessible label for the button to load more recently updated content items, providing context for screen reader users',
	},
	showLess: {
		id: 'recently-updated-macro.show-less',
		defaultMessage: 'Show less',
		description: 'Link to collapse the list back to the initial number of items',
	},
	filterLabel: {
		id: 'recently-updated-macro.filter-label',
		defaultMessage: 'Viewing:',
		description: 'Label before the content type filter dropdown',
	},
	filterAll: {
		id: 'recently-updated-macro.filter-all',
		defaultMessage: 'All',
		description: 'Option in content type filter dropdown to show all content types',
	},
	filterPages: {
		id: 'recently-updated-macro.filter-pages',
		defaultMessage: 'Pages',
		description: 'Option in content type filter dropdown to show only pages',
	},
	filterBlogPosts: {
		id: 'recently-updated-macro.filter-blog-posts',
		defaultMessage: 'Blog Posts',
		description: 'Option in content type filter dropdown to show only blog posts',
	},
	filterComments: {
		id: 'recently-updated-macro.filter-comments',
		defaultMessage: 'Comments',
		description: 'Option in content type filter dropdown to show only comments',
	},
	filterAttachments: {
		id: 'recently-updated-macro.filter-attachments',
		defaultMessage: 'Attachments',
		description: 'Option in content type filter dropdown to show only attachments',
	},
	filterWhiteboards: {
		id: 'recently-updated-macro.filter-whiteboards',
		defaultMessage: 'Whiteboards',
		description: 'Option in content type filter dropdown to show only whiteboards',
	},
	filterDatabases: {
		id: 'recently-updated-macro.filter-databases',
		defaultMessage: 'Databases',
		description: 'Option in content type filter dropdown to show only databases',
	},
	filterEmbeds: {
		id: 'recently-updated-macro.filter-embeds',
		defaultMessage: 'Embeds',
		description: 'Option in content type filter dropdown to show only embeds',
	},
	createdBy: {
		id: 'recently-updated-macro.created-by',
		defaultMessage: 'created by {author}',
		description: 'Description of a newly created item, with the author name',
	},
	updatedBy: {
		id: 'recently-updated-macro.updated-by',
		defaultMessage: 'updated by {author}',
		description: 'Description of an updated item, with the author name',
	},
	createdOn: {
		id: 'recently-updated-macro.created-on',
		defaultMessage: 'created {date}',
		description: 'Description of a newly created item, with the relative date',
	},
	updatedOn: {
		id: 'recently-updated-macro.updated-on',
		defaultMessage: 'updated {date}',
		description: 'Description of an updated item, with the relative date',
	},
	viewChanges: {
		id: 'recently-updated-macro.view-changes',
		defaultMessage: 'view changes',
		description: 'Link to view the diff/changes for a recently updated page',
	},
	permalink: {
		id: 'recently-updated-macro.permalink',
		defaultMessage: 'Permalink',
		description: 'Link text for the permanent link to a content item',
	},
	loadingLabel: {
		id: 'recently-updated-macro.loading',
		defaultMessage: 'Loading recently updated content…',
		description: 'Accessible label shown while the macro is loading',
	},
	errorMessage: {
		id: 'recently-updated-macro.error',
		defaultMessage: 'Unable to load recently updated content. Please refresh to try again.',
		description: 'Error message shown when recently updated content fails to load',
	},
	editCta: {
		id: 'recently-updated-macro.edit-cta',
		defaultMessage: 'Edit this macro to add content.',
		description:
			'Call to action shown in the empty state when in preview/edit mode to prompt the user to configure the macro',
	},
	contributedBy: {
		id: 'recently-updated-macro.contributed-by',
		defaultMessage: 'contributed by {author}',
		description: 'Shows the author who contributed to a page or blog post',
	},
	commentedBy: {
		id: 'recently-updated-macro.commented-by',
		defaultMessage: 'commented by {author}',
		description: 'Shows the author who added a comment',
	},
	commentedByPrefix: {
		id: 'recently-updated-macro.commented-by-prefix',
		defaultMessage: 'commented by',
		description: 'Prefix text for comment author (used when author is rendered separately)',
	},
	attachedBy: {
		id: 'recently-updated-macro.attached-by',
		defaultMessage: 'attached by {author}',
		description: 'Shows the author who attached a file',
	},
	attachedByPrefix: {
		id: 'recently-updated-macro.attached-by-prefix',
		defaultMessage: 'attached by',
		description: 'Prefix text for attachment author (used when author is rendered separately)',
	},
	contributedByPrefix: {
		id: 'recently-updated-macro.contributed-by-prefix',
		defaultMessage: 'contributed by',
		description: 'Prefix text for contributor (used when author is rendered separately)',
	},
	contributedOn: {
		id: 'recently-updated-macro.contributed-on',
		defaultMessage: 'contributed {date}',
		description: 'Shows when an item was contributed to (used in sidebar view)',
	},
});
